import { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom-v5-compat";

export const useTimeoutSearchParam = (
  paramName: string,
  time: number = 5000,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get(paramName) === "cancelled") {
      const timer = setTimeout(() => {
        setSearchParams((searchParams) => {
          searchParams.delete(paramName);
          return searchParams;
        });
      }, time);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);
  const param = searchParams.get(paramName);
  return param;
};

export const useTimeoutMessage = (time: number = 5000) => {
  const [errorMessage, setError] = useState<string | undefined>();
  const setErrorMessage = (message: string) => {
    setError(message);
    setTimeout(() => {
      setError(undefined);
    }, time);
  };
  return { errorMessage, setErrorMessage };
};
